import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import type { ProductReferenceCalculationSourceEnum } from "@/features/diagnostics/types";
import type {
    Product,
    ProductData,
    ProductReference,
    SmartNumberDescription,
    SmartNumberMapping,
} from "@/features/sub-families/types";
import Logger from "@/lib/logger.ts";
import {
    getProductReferenceBySmartNumberMapping,
    type ProductReferenceDiagnosticsContext,
} from "@/lib/product-reference.ts";
import { type Nullable, type Nullish } from "@/types";

export const getCurrentProductReference = (
    products: ProductData,
    smartNumberMapping: SmartNumberMapping,
    smartNumberDescription: SmartNumberDescription,
    source: ProductReferenceCalculationSourceEnum,
): Nullable<[ProductReference, Product]> => {
    const diagnostics: ProductReferenceDiagnosticsContext = { source, products };

    const reference = getProductReferenceBySmartNumberMapping(smartNumberMapping, smartNumberDescription, diagnostics);
    const currentProduct = (products[reference] as Nullish<Product>) ?? null;

    if (currentProduct === null) {
        Logger.error("Could not map the product mapping to a product!");
        DiagnosticsStore.collectEventLog("error", "Could not map the product mapping to a product!");

        return null;
    }

    Logger.success("Found current product by mapping!");
    DiagnosticsStore.collectEventLog("success", `Found product by reference ${reference}`);

    return [reference, currentProduct];
};
